import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { RegionsConfigurationService } from './../service';
import {
	createBusyPictureLesson,
	createBusyPictureLessonFailure,
	createBusyPictureLessonSuccess,
	createGrammarLesson,
	createGrammarLessonFailure,
	createGrammarLessonSuccess,
	createLessonCategory,
	createLessonCategoryFailure,
	createLessonCategorySuccess,
	createLessonItemModifier,
	createLessonItemModifierFailure,
	createLessonItemModifierSuccess,
	createLexicaryLesson,
	createLexicaryLessonFailure,
	createLexicaryLessonSuccess,
	createNumberCombinationLesson,
	createNumberCombinationLessonFailure,
	createNumberCombinationLessonSuccess,
	createSceneMatchingLesson,
	createSceneMatchingLessonFailure,
	createSceneMatchingLessonSuccess,
	createSentenceLesson,
	createSentenceLessonFailure,
	createSentenceLessonSuccess,
	createSightWordsLesson,
	createSightWordsLessonFailure,
	createSightWordsLessonSuccess,
	createSortingLesson,
	createSortingLessonFailure,
	createSortingLessonSuccess,
	createTimeLesson,
	createTimeLessonFailure,
	createTimeLessonSuccess,
	createVerbLesson,
	createVerbLessonFailure,
	createVerbLessonSuccess,
	createVocabLesson,
	createVocabLessonFailure,
	createVocabLessonSuccess,
	deleteLesson,
	deleteLessonCategory,
	deleteLessonCategoryFailure,
	deleteLessonCategorySuccess,
	deleteLessonFailure,
	deleteLessonItemModifier,
	deleteLessonItemModifierFailure,
	deleteLessonItemModifierSuccess,
	deleteLessonSuccess,
	getBusyPictureLessonToUpdate,
	getBusyPictureLessonToUpdateFailure,
	getBusyPictureLessonToUpdateSuccess,
	getGrammarLessonToUpdate,
	getGrammarLessonToUpdateFailure,
	getGrammarLessonToUpdateSuccess,
	getLessonCategories,
	getLessonCategoriesFailure,
	getLessonCategoriesSuccess,
	getLessons,
	getLessonsFailure,
	getLessonsSuccess,
	getLexicaryLessonToUpdate,
	getLexicaryLessonToUpdateFailure,
	getLexicaryLessonToUpdateSuccess,
	getNewLessonOrder,
	getNumberCombinationLessonToUpdate,
	getNumberCombinationLessonToUpdateFailure,
	getNumberCombinationLessonToUpdateSuccess,
	getSceneMatchingLessonToUpdate,
	getSceneMatchingLessonToUpdateFailure,
	getSceneMatchingLessonToUpdateSuccess,
	getSentenceLessonToUpdate,
	getSentenceLessonToUpdateFailure,
	getSentenceLessonToUpdateSuccess,
	getSentenceLessonsWithOrderLessThanVocabLessonNewOrder,
	getSentenceLessonsWithOrderLessThanVocabLessonNewOrderFailure,
	getSentenceLessonsWithOrderLessThanVocabLessonNewOrderSuccess,
	getSentencesWithVocabLessonWord,
	getSentencesWithVocabLessonWordFailure,
	getSentencesWithVocabLessonWordSuccess,
	getSentencesWithVocabLessonWords,
	getSentencesWithVocabLessonWordsFailure,
	getSentencesWithVocabLessonWordsSuccess,
	getSightWordsLessonToUpdate,
	getSightWordsLessonToUpdateFailure,
	getSightWordsLessonToUpdateSuccess,
	getSortingLessonToUpdate,
	getSortingLessonToUpdateFailure,
	getSortingLessonToUpdateSuccess,
	getTimeLessonToUpdate,
	getTimeLessonToUpdateFailure,
	getTimeLessonToUpdateSuccess,
	getVerbLessonToUpdate,
	getVerbLessonToUpdateFailure,
	getVerbLessonToUpdateSuccess,
	getVocabLessonToUpdate,
	getVocabLessonToUpdateFailure,
	getVocabLessonToUpdateSuccess,
	searchLessonCategories,
	searchLessonItemModifiers,
	searchLessons,
	searchSentenceLessonVocabWords,
	searchVocabWords,
	setNewLessonOrder,
	setSearchLessonCategoriesResult,
	setSearchLessonItemModifiersResult,
	setSearchLessonsAutoCompleteResult,
	setSearchSentenceLessonVocabWordsAutoCompleteResult,
	setSearchVocabWordsAutoCompleteResult,
	updateBusyPictureLesson,
	updateBusyPictureLessonFailure,
	updateBusyPictureLessonSuccess,
	updateGrammarLesson,
	updateGrammarLessonFailure,
	updateGrammarLessonSuccess,
	updateLessonCategory,
	updateLessonCategoryFailure,
	updateLessonCategorySuccess,
	updateLessonItemModifier,
	updateLessonItemModifierFailure,
	updateLessonItemModifierSuccess,
	updateLexicaryLesson,
	updateLexicaryLessonFailure,
	updateLexicaryLessonSuccess,
	updateNumberCombinationLesson,
	updateNumberCombinationLessonFailure,
	updateNumberCombinationLessonSuccess,
	updateSceneMatchingLesson,
	updateSceneMatchingLessonFailure,
	updateSceneMatchingLessonSuccess,
	updateSentenceLesson,
	updateSentenceLessonFailure,
	updateSentenceLessonSuccess,
	updateSightWordsLesson,
	updateSightWordsLessonFailure,
	updateSightWordsLessonSuccess,
	updateSortingLesson,
	updateSortingLessonFailure,
	updateSortingLessonSuccess,
	updateTimeLesson,
	updateTimeLessonFailure,
	updateTimeLessonSuccess,
	updateVerbLesson,
	updateVerbLessonFailure,
	updateVerbLessonSuccess,
	updateVocabLesson,
	updateVocabLessonFailure,
	updateVocabLessonSuccess,
} from './slice';

function* getLessonsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getLessons(action.payload);
		yield put(getLessonsSuccess(data));
	} catch (e) {
		yield put(getLessonsFailure(e));
		console.error(e);
	}
}

function* searchLessonsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.searchLessonsAutoComplete(
			action.payload,
		);
		yield put(
			setSearchLessonsAutoCompleteResult({
				lessons: data,
			}),
		);
	} catch (e) {
		console.error(e);
	}
}

function* deleteLessonHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield questionService.deleteLesson(
			action.payload.lessonId,
			action.payload.lessonType,
		);
		yield put(deleteLessonSuccess({}));
		toast('Lesson deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteLessonFailure(e));
	}
}

function* getNewLessonOrderHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data =
			yield regionsConfigurationService.getRegionNewLessonDefaultOrder(
				action.payload.region,
			);
		yield put(setNewLessonOrder(data));
	} catch (e) {
		yield put(setNewLessonOrder({ order: 1 }));
	}
}

function* createVocabLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createVocabLesson(action.payload);
		yield put(createVocabLessonSuccess({}));
		toast('Vocabulary lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createVocabLessonFailure({}));
	}
}

function* getVocabLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getVocabLesson(
			action.payload.lessonId,
		);
		yield put(
			getVocabLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getVocabLessonToUpdateFailure({}));
	}
}

function* updateVocabLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateVocabLesson(action.payload);
		yield put(updateVocabLessonSuccess({}));
		toast('Vocabulary lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateVocabLessonFailure({}));
	}
}

function* createVerbLessonHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createVerbLesson(action.payload);
		yield put(createVerbLessonSuccess({}));
		toast('Verb lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createVerbLessonFailure({}));
	}
}

function* getVerbLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getVerbLesson(
			action.payload.lessonId,
		);
		yield put(
			getVerbLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getVerbLessonToUpdateFailure({}));
	}
}

function* updateVerbLessonHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateVerbLesson(action.payload);
		yield put(updateVerbLessonSuccess({}));
		toast('Verb lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateVerbLessonFailure({}));
	}
}

function* getSentencesWithVocabLessonWordHanlder(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data =
			yield regionsConfigurationService.getSentencesWithVocabLessonWord(
				action.payload.vocabWordId,
			);
		yield put(
			getSentencesWithVocabLessonWordSuccess({
				sentences: data,
			}),
		);
	} catch (e) {
		yield put(getSentencesWithVocabLessonWordFailure({}));
	}
}

function* getSentencesWithVocabLessonWordsHanlder(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data =
			yield regionsConfigurationService.getSentencesWithVocabLessonWords(
				action.payload.vocabLessonId,
			);
		yield put(
			getSentencesWithVocabLessonWordsSuccess({
				sentences: data,
			}),
		);
	} catch (e) {
		yield put(getSentencesWithVocabLessonWordsFailure({}));
	}
}

function* getSentenceLessonsWithOrderLessThanVocabLessonNewOrderHanlder(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data =
			yield regionsConfigurationService.getSentenceLessonsWithOrderLessThanVocabLessonNewOrder(
				action.payload.vocabLessonId,
				action.payload.newOrder,
			);
		yield put(
			getSentenceLessonsWithOrderLessThanVocabLessonNewOrderSuccess({
				sentenceLessons: data,
			}),
		);
	} catch (e) {
		yield put(
			getSentenceLessonsWithOrderLessThanVocabLessonNewOrderFailure({}),
		);
	}
}

function* createSentenceLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createSentenceLesson(action.payload);
		yield put(createSentenceLessonSuccess({}));
		toast('Sentence lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createSentenceLessonFailure({}));
	}
}

function* getSentenceLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getSentenceLesson(
			action.payload.lessonId,
		);
		yield put(
			getSentenceLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getSentenceLessonToUpdateFailure({}));
	}
}

function* updateSentenceLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateSentenceLesson(action.payload);
		yield put(updateSentenceLessonSuccess({}));
		toast('Sentence lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSentenceLessonFailure({}));
	}
}

function* searchSentenceLessonVocabWordsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data =
			yield regionsConfigurationService.searchSentenceLessonVocabWords(
				action.payload.searchKey,
			);
		yield put(
			setSearchSentenceLessonVocabWordsAutoCompleteResult({
				sentenceLessonVocabWords: data,
			}),
		);
	} catch (e) {
		console.log(e);
	}
}

function* createLexicaryLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createLexicaryLesson(action.payload);
		yield put(createLexicaryLessonSuccess({}));
		toast('Lexicary lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createLexicaryLessonFailure({}));
	}
}

function* getLexicaryLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getLexicaryLesson(
			action.payload.lessonId,
		);
		yield put(
			getLexicaryLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getLexicaryLessonToUpdateFailure({}));
	}
}

function* updateLexicaryLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateLexicaryLesson(action.payload);
		yield put(updateLexicaryLessonSuccess({}));
		toast('Lexicary lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateLexicaryLessonFailure({}));
	}
}

function* searchLessonItemModifiersHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.searchLessonItemModifiers(
			action.payload.searchKey,
		);
		yield put(
			setSearchLessonItemModifiersResult({ lessonItemModifiers: data }),
		);
	} catch (e) {
		console.error(e);
	}
}

function* createLessonItemModifierHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.createLessonItemModifier(
			action.payload.lessonItemModifier,
		);
		yield put(createLessonItemModifierSuccess({ data }));
		toast('Lesson item modifier created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createLessonItemModifierFailure({}));
	}
}

function* updateLessonItemModifierHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.updateLessonItemModifier(
			action.payload.lessonItemModifier,
		);
		yield put(updateLessonItemModifierSuccess({ data }));
		toast('Lesson item modifier updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateLessonItemModifierFailure({}));
	}
}

function* deleteLessonItemModifierHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.deleteLessonItemModifier(
			action.payload.lessonItemModifierId,
		);
		yield put(deleteLessonItemModifierSuccess({ data }));
		toast('Lesson item modifier deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteLessonItemModifierFailure({}));
	}
}

function* createGrammarLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createGrammarLesson(action.payload);
		yield put(createGrammarLessonSuccess({}));
		toast('Grammar lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createGrammarLessonFailure({}));
	}
}

function* getGrammarLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getGrammarLesson(
			action.payload.lessonId,
		);
		yield put(
			getGrammarLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getGrammarLessonToUpdateFailure({}));
	}
}

function* updateGrammarLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateGrammarLesson(action.payload);
		yield put(updateGrammarLessonSuccess({}));
		toast('Grammar lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateGrammarLessonFailure({}));
	}
}

function* createSortingLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createSortingLesson(action.payload);
		yield put(createSortingLessonSuccess({}));
		toast('Sorting lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createSortingLessonFailure({}));
	}
}

function* getSortingLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getSortingLesson(
			action.payload.lessonId,
		);
		yield put(
			getSortingLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getSortingLessonToUpdateFailure({}));
	}
}

function* updateSortingLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateSortingLesson(action.payload);
		yield put(updateSortingLessonSuccess({}));
		toast('Sorting lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSortingLessonFailure({}));
	}
}

function* getLessonCategoriesHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.getLessonCategories(
			action.payload.page,
			action.payload.searchKey,
			action.payload.id,
		);
		yield put(getLessonCategoriesSuccess(data));
	} catch (e) {
		yield put(getLessonCategoriesFailure(e));
		console.error(e);
	}
}

function* createLessonCategoryHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		yield service.createLessonCategory(action.payload.lessonCategory);
		yield put(createLessonCategorySuccess({}));
		toast('Lesson category created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createLessonCategoryFailure(e));
		console.error(e);
	}
}

function* updateLessonCategoryHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.updateLessonCategory(
			action.payload.lessonCategory,
		);
		yield put(updateLessonCategorySuccess({ data }));
		toast('Lesson category updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateLessonCategoryFailure(e));
		console.error(e);
	}
}

function* deleteLessonCategoryHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		yield service.deleteLessonCategory(action.payload.lessonCategoryId);
		yield put(deleteLessonCategorySuccess({}));
		toast('LessonCategory deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteLessonCategoryFailure(e));
		console.error(e);
	}
}
function* searchLessonCategoriesHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new RegionsConfigurationService(globalApplicationContext);
		const data = yield service.searchLessonCategories(action.payload.searchKey);
		yield put(setSearchLessonCategoriesResult({ lessonCategories: data }));
	} catch (e) {
		console.error(e);
	}
}

function* createBusyPictureLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createBusyPictureLesson(action.payload);
		yield put(createBusyPictureLessonSuccess({}));
		toast('Busy picture lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createBusyPictureLessonFailure({}));
	}
}

function* getBusyPictureLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getBusyPictureLesson(
			action.payload.lessonId,
		);
		yield put(
			getBusyPictureLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getBusyPictureLessonToUpdateFailure({}));
	}
}

function* updateBusyPictureLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateBusyPictureLesson(action.payload);
		yield put(updateBusyPictureLessonSuccess({}));
		toast('Busy picture lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateBusyPictureLessonFailure({}));
	}
}

function* createNumberCombinationLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createNumberCombinationLesson(
			action.payload,
		);
		yield put(createNumberCombinationLessonSuccess({}));
		toast('Number combination lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createNumberCombinationLessonFailure({}));
	}
}

function* getNumberCombinationLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getNumberCombinationLesson(
			action.payload.lessonId,
		);
		yield put(
			getNumberCombinationLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getNumberCombinationLessonToUpdateFailure({}));
	}
}

function* updateNumberCombinationLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateNumberCombinationLesson(
			action.payload,
		);
		yield put(updateNumberCombinationLessonSuccess({}));
		toast('Number combination lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateNumberCombinationLessonFailure({}));
	}
}

function* createSightWordsLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createSightWordsLesson(action.payload);
		yield put(createSightWordsLessonSuccess({}));
		toast('Sight words lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createSightWordsLessonFailure({}));
	}
}

function* getSightWordsLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getSightWordsLesson(
			action.payload.lessonId,
		);
		yield put(
			getSightWordsLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getSightWordsLessonToUpdateFailure({}));
	}
}

function* updateSightWordsLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateSightWordsLesson(action.payload);
		yield put(updateSightWordsLessonSuccess({}));
		toast('Sight words lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSightWordsLessonFailure({}));
	}
}

function* createTimeLessonHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createTimeLesson(action.payload);
		yield put(createTimeLessonSuccess({}));
		toast('Time lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createTimeLessonFailure({}));
	}
}

function* getTimeLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getTimeLesson(
			action.payload.lessonId,
		);
		yield put(
			getTimeLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getTimeLessonToUpdateFailure({}));
	}
}

function* updateTimeLessonHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateTimeLesson(action.payload);
		yield put(updateTimeLessonSuccess({}));
		toast('Time lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateTimeLessonFailure({}));
	}
}

// --

function* createSceneMatchingLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.createSceneMatchingLesson(action.payload);
		yield put(createSceneMatchingLessonSuccess({}));
		toast('Scene matching lesson created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createSceneMatchingLessonFailure({}));
	}
}

function* getSceneMatchingLessonToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getSceneMatchingLesson(
			action.payload.lessonId,
		);
		yield put(
			getSceneMatchingLessonToUpdateSuccess({
				lesson: data,
			}),
		);
	} catch (e) {
		yield put(getSceneMatchingLessonToUpdateFailure({}));
	}
}

function* updateSceneMatchingLessonHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateSceneMatchingLesson(action.payload);
		yield put(updateSceneMatchingLessonSuccess({}));
		toast('Scene matching lesson updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSceneMatchingLessonFailure({}));
	}
}

function* searchVocabWordsByPreviousLessonsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new RegionsConfigurationService(
			globalApplicationContext,
		);
		const data = yield sentenceService.searchVocabWordsAutoComplete(
			action.payload,
		);
		yield put(setSearchVocabWordsAutoCompleteResult(data));
	} catch (e) {
		console.error(e);
	}
}

export function* regionsConfigurationSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getLessons, getLessonsHandler),
		takeEvery(deleteLesson, deleteLessonHandler),
		takeEvery(searchLessons, searchLessonsHandler),
		takeEvery(getNewLessonOrder, getNewLessonOrderHandler),
		takeEvery(createVocabLesson, createVocabLessonHandler),
		takeEvery(getVocabLessonToUpdate, getVocabLessonToUpdateHandler),
		takeEvery(updateVocabLesson, updateVocabLessonHandler),
		takeEvery(createVerbLesson, createVerbLessonHandler),
		takeEvery(getVerbLessonToUpdate, getVerbLessonToUpdateHandler),
		takeEvery(updateVerbLesson, updateVerbLessonHandler),
		takeEvery(
			getSentencesWithVocabLessonWord,
			getSentencesWithVocabLessonWordHanlder,
		),
		takeEvery(
			getSentencesWithVocabLessonWords,
			getSentencesWithVocabLessonWordsHanlder,
		),
		takeEvery(
			getSentenceLessonsWithOrderLessThanVocabLessonNewOrder,
			getSentenceLessonsWithOrderLessThanVocabLessonNewOrderHanlder,
		),
		takeEvery(
			searchSentenceLessonVocabWords,
			searchSentenceLessonVocabWordsHandler,
		),
		takeEvery(getSentenceLessonToUpdate, getSentenceLessonToUpdateHandler),
		takeEvery(createSentenceLesson, createSentenceLessonHandler),
		takeEvery(updateSentenceLesson, updateSentenceLessonHandler),
		takeEvery(createLexicaryLesson, createLexicaryLessonHandler),
		takeEvery(getLexicaryLessonToUpdate, getLexicaryLessonToUpdateHandler),
		takeEvery(updateLexicaryLesson, updateLexicaryLessonHandler),
		takeEvery(searchLessonItemModifiers, searchLessonItemModifiersHandler),
		takeEvery(createLessonItemModifier, createLessonItemModifierHandler),
		takeEvery(updateLessonItemModifier, updateLessonItemModifierHandler),
		takeEvery(deleteLessonItemModifier, deleteLessonItemModifierHandler),

		takeEvery(getGrammarLessonToUpdate, getGrammarLessonToUpdateHandler),
		takeEvery(createGrammarLesson, createGrammarLessonHandler),
		takeEvery(updateGrammarLesson, updateGrammarLessonHandler),

		takeEvery(getSortingLessonToUpdate, getSortingLessonToUpdateHandler),
		takeEvery(createSortingLesson, createSortingLessonHandler),
		takeEvery(updateSortingLesson, updateSortingLessonHandler),

		takeEvery(getLessonCategories, getLessonCategoriesHandler),
		takeEvery(createLessonCategory, createLessonCategoryHandler),
		takeEvery(updateLessonCategory, updateLessonCategoryHandler),
		takeEvery(deleteLessonCategory, deleteLessonCategoryHandler),
		takeEvery(searchLessonCategories, searchLessonCategoriesHandler),

		takeEvery(createBusyPictureLesson, createBusyPictureLessonHandler),
		takeEvery(
			getBusyPictureLessonToUpdate,
			getBusyPictureLessonToUpdateHandler,
		),
		takeEvery(updateBusyPictureLesson, updateBusyPictureLessonHandler),

		takeEvery(
			createNumberCombinationLesson,
			createNumberCombinationLessonHandler,
		),
		takeEvery(
			getNumberCombinationLessonToUpdate,
			getNumberCombinationLessonToUpdateHandler,
		),
		takeEvery(
			updateNumberCombinationLesson,
			updateNumberCombinationLessonHandler,
		),

		takeEvery(createSightWordsLesson, createSightWordsLessonHandler),
		takeEvery(getSightWordsLessonToUpdate, getSightWordsLessonToUpdateHandler),
		takeEvery(updateSightWordsLesson, updateSightWordsLessonHandler),

		takeEvery(createTimeLesson, createTimeLessonHandler),
		takeEvery(getTimeLessonToUpdate, getTimeLessonToUpdateHandler),
		takeEvery(updateTimeLesson, updateTimeLessonHandler),

		// --

		takeEvery(createSceneMatchingLesson, createSceneMatchingLessonHandler),
		takeEvery(
			getSceneMatchingLessonToUpdate,
			getSceneMatchingLessonToUpdateHandler,
		),
		takeEvery(updateSceneMatchingLesson, updateSceneMatchingLessonHandler),

		takeEvery(searchVocabWords, searchVocabWordsByPreviousLessonsHandler),
	]);
}
